import React from 'react';
import { getTeamLogoPath } from '../../utils/teams';
import './ConsolidatedByeCard.css';

const ConsolidatedByeCard = ({ byeMatches, adminMode, onStatusChange }) => {
  if (!byeMatches || byeMatches.length === 0) {
    return null;
  }

  return (
    <div className="match-card bye-match">
      <div className="consolidated-bye-card-content">
        {/* Column 1: Lock Status Icon */}
        <div className="lock-status-icon">
          <i className="fa-solid fa-lock"></i>
        </div>

        {/* Column 2: Bye Round Label */}
        <div className="bye-info-column">
          <div className="venue-name bye-round-label">BYE ROUND</div>
          <div className="bye-count">{byeMatches.length} {byeMatches.length === 1 ? 'team' : 'teams'}</div>
        </div>

        {/* Column 3: All teams with byes - horizontal layout */}
        <div className="bye-teams-container">
          {byeMatches.map((match) => (
            <div key={match.id} className="bye-team-item">
              <img
                src={getTeamLogoPath(match.homeTeam.id)}
                alt={match.homeTeam.name}
                className="bye-team-logo"
              />
              <span className="bye-team-name">{match.homeTeam.name}</span>

              {/* Admin status dropdown */}
              {adminMode && (
                <select
                  className="admin-status-dropdown bye-status-dropdown"
                  value={match.status}
                  onChange={(e) => onStatusChange(match.id, e.target.value)}
                >
                  <option value="scheduled">Scheduled</option>
                  <option value="in_progress">In Progress</option>
                  <option value="completed">Completed</option>
                  <option value="postponed">Postponed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConsolidatedByeCard;
